module.exports = __webpack_public_path__ + "img/lg_ring_y_c_null_0.8a788688.png";